<template>
    <!-- <div class="page" v-if="isDataLoaded"> -->
        <div class="page" >
            <van-nav-bar
            title=""
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            />
        <!-- 个人资料 -->
        <div class="b3">
            <div class="list1" data-flex="cross:center">
                <p class="tit" data-flex-box="1">头像</p>
                <img class="img" :src="infodata.headimg" alt="">
            </div>
            <div class="list" data-flex="cross:center">
                <p class="tit2" data-flex-box="1">昵称</p>
                <p class="txt f-toe">{{ infodata.nickname }}</p>
            </div>
            <div class="list" data-flex="cross:center">
                <p class="tit2" data-flex-box="1">手机号</p>
                <p class="txt f-toe">{{infodata.tel}}</p>
                <!-- <p class="txt f-toe" v-if="!isEmpty(profile.mobileNumber)">{{ profile.mobileNumber }}</p> -->
                <!-- <template v-else>
                    <p class="txt f-fs12 f-fc10" data-flex-box="1">绑定手机为了更好的给您实时了解服务进度</p>
                    <p class="txt f-fc6" data-flex-box="0" @click="toUrl('/my/bind')">绑定</p>
                </template> -->
            </div>
        </div>
        <!-- <div class="b2">
            <div class="head" data-flex="cross:center">
                <p data-flex-box="1" class="f-fwb f-fc1">客户信息管理</p>
                <div data-flex="cross:center" @click="toUrl('/customer/list')">
                    <p class="f-fc6 mr-10">去添加</p>
                    <img class="img" src="../../assets/images/angle-right.png" alt="">
                </div>
            </div>
            <div class="noData" data-flex="cross:center" v-if="isEmpty(customerObj)">
                <img class="img" src="../../assets/images/a-01.png" alt="">
                <p class="txt">暂无添加任何客户信息</p>
            </div>
            <div class="address-data pt-10" v-else>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">客户名称</p>
                    <span data-flex-box="1">{{ customerObj.customerName }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">联系人</p>
                    <span data-flex-box="1">{{ customerObj.contactName }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">产品名称</p>
                    <span data-flex-box="1">{{ customerObj.productName }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">设备型号</p>
                    <span data-flex-box="1">{{ customerObj.unitType }}</span>
                </div>
                <div data-flex="cross:center" class="item">
                    <p data-flex-box="0">机身号码</p>
                    <span data-flex-box="1">{{ customerObj.deviceNo }}</span>
                </div>
                <div data-flex="cross:center" class="address-info">
                    <img class="img" src="../../assets/images/a-01.png" alt="">
                    <p class="txt f-fwb">{{ customerObj.fullAddress }}</p>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Field, NavBar } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        [Button.name]: Button,
        [Field.name]: Field,
        [NavBar.name]:NavBar
    },
    data() {
        return {
            show: false,
            liIndex: 0,
            checked: ['a'],
            profile: {},
            customerObj: {},
            infodata:{
                headimg:""
            }
        }
    },
    methods: {
        onClickLeft(){
            this.$router.go(-1);
        },
        async getUserInfo(){
            const promise = this.apiGet('my.userInfo')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.infodata = apiResult.obj
            console.log("this.infodata=>",this.infodata);
        },
        async getProfile(id) {
            const promise = this.apiGet('fans.profile')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.profile = apiResult.obj
            this.isDataLoaded = true
        },
        async getCustomerList() {
            const promise = this.apiGet('my.customer.list')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }
            this.customerObj = apiResult.list.find(it => {
                return it.isDefault == 1
            })

        },
        toUrl(url) {
            this.$router.push(url)
        }
    },
    mounted() {

    },
    created() {
        // this.getProfile()
        // this.getCustomerList()
        this.getUserInfo()
    }
}
</script>

<style lang="less" scoped>
.page {
    // padding-bottom: 150px;

    .list1{
        height: 156px;
        padding: 0 30px;
        box-sizing: border-box;
        border-bottom: solid 1px #F9F5F5;
        .tit {
            min-width: 120px;
            height: 42px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 15px;
            color: #000000;
            line-height: 42px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
        }
    }

    .list {
        height: 180px;
        padding: 0 30px;
        box-sizing: border-box;
        border-bottom: solid 1px #F9F5F5;
        display: flex;
        flex-wrap: wrap;

        .tit2 {
            min-width: 690px;
            height: 42px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 15px;
            color: #000000;
            line-height: 42px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .txt{
            // width: 218px;
            height: 42px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 15px;
            color: #A2A2A2;
            line-height: 42px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
        }

        p {
            font-size: 15px;
        }
    }

    .b3 {
        background: #ffffff;
        // margin-top: 20px;
        width: 100vw;


    }

    // .b2 {
    //     background: #fff;
    //     border-radius: 10px 10px 0 0;
    //     margin-top: 20px;

    //     .head {
    //         height: 100px;
    //         padding: 20px 30px;
    //         box-sizing: border-box;
    //         border-bottom: solid 1px #F9F5F5;

    //         p {
    //             font-size: 15px;
    //             line-height: 24px;
    //         }

    //         img {
    //             width: 24px;
    //             height: 24px;
    //         }
    //     }

    //     .noData {
    //         height: 160px;
    //         padding: 20px 30px;
    //         box-sizing: border-box;

    //         img {
    //             width: 44px;
    //             height: 51px;
    //             margin-right: 20px;
    //         }

    //         .txt {
    //             font-size: 15px;
    //             color: #B5B5B5;
    //         }
    //     }

    //     .address-data {
    //         .item {
    //             padding: 10px;
    //             box-sizing: border-box;

    //             p {
    //                 width: 160px;
    //                 text-align: right;
    //                 font-size: 14px;
    //                 padding-right: 20px;
    //             }

    //             span {
    //                 font-size: 14px;
    //                 color: #376CFE;
    //             }
    //         }

    //         .address-info {

    //             padding: 20px 30px;
    //             box-sizing: border-box;

    //             img {
    //                 width: 44px;
    //                 height: 51px;
    //                 margin-right: 20px;
    //             }

    //             .txt {
    //                 font-size: 14px;
    //                 color: #000;
    //             }
    //         }
    //     }
    // }
}
</style>